import React from 'react';
import {
  ProjectDetailsField,
  ProjectDetailsFieldType,
  ProjectType,
  useProjectDetailsFieldsService
} from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import {
  BaseInputProps,
  Dropdown,
  Header5,
  LoadingAnimation,
  useFormContextRequired,
} from 'ui-builder';
import useProjectDetailsFieldTypeHelper
  from '../../../projectdetails/projectDetailsFieldTypeHelper';

export interface BaseDetailsFieldDropdownProps extends BaseInputProps {
  projectType: ProjectType,
  types?: ProjectDetailsFieldType[],
  fields: ProjectDetailsField[]
}

function BaseDetailsFieldDropdown(props: BaseDetailsFieldDropdownProps) {
  const standardFields = [
    {
      value: 'startDate',
      label: 'Start Date (Date)',
      fieldType: ProjectDetailsFieldType.DATE
    },
    {
      value: 'endDate',
      label: 'End Date (Date)',
      fieldType: ProjectDetailsFieldType.DATE
    }
  ];

  const typeHelper = useProjectDetailsFieldTypeHelper();

  const getDataFunc = async () => {
    const fields = props.fields;

    return [
      ...standardFields
        .filter((f) => !props.types || props.types.includes(f.fieldType)),
      ...fields
        .filter((field) => !props.types || props.types.includes(field.fieldType))
        .map((field) => ({
          value: `detailsField:${field.id.toString()}`,
          label: `${field.name} (${typeHelper.getLabel(field.fieldType)})`
        }))
    ];
  };

  const { data } = useDataLoaderNew(getDataFunc);

  if (data) {
    return (
      <Dropdown
        options={data}
        {...props}
      />
    );
  } else {
    return (<LoadingAnimation />);
  }
}

export function PerMarketFieldsDropdowns(
  props: {
    projectType: ProjectType,
    types?: ProjectDetailsFieldType[],
  }
) {
  const projectDetailsService = useProjectDetailsFieldsService();

  const { data: fields } = useDataLoaderNew(
    () => projectDetailsService.getAllSetupAreasFields(props.projectType)
  );

  const { data: formData } = useFormContextRequired<{
    mappings: {
      setupAreaId: number;
      setupAreaName: string;
      nekstFieldId?: string;
    }[]
  }>();



  if (fields) {
    return (
      <>
        <Header5>Choose Mapping For Each Market</Header5>
        {formData?.mappings.map((mappingEntry, index) => {
          return (
            <BaseDetailsFieldDropdown
              fields={(fields
                .filter((item) => item._setupArea?.id === mappingEntry.setupAreaId))}
              projectType={props.projectType}
              source={`mappings.${index}.nekstFieldId`}
              label={`"${mappingEntry.setupAreaName}" Market Box`}
              types={props.types}
            />
          );
        })}
      </>
    );
  } else {
    return (<LoadingAnimation />);
  }
}
